import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import ReleaseItemWeb from "./releaseitemWeb";
import ReleaseItemMobile from "./releaseItemMobile";

const LastRelease = () => {
  return (
    <Container>
      <Typography size="2xl" weight="medium" mb="2.4">
        Last Release
      </Typography>
      <Body>
        <ReleaseItemWeb />
        <ReleaseItemMobile />
      </Body>
    </Container>
  );
};

export default LastRelease;

const Container = styled.div`
  margin-bottom: 3.2rem;
`;

const Body = styled.div`
  width: 100%;
`;
